
// '송재영', '송병우', '윤경한', '조원익', '이다빈', '김진선', '김진우', '이해준', '이혜원',
const nameList = [ '\n' +
' ██▓███   ▄▄▄       ██▀███   ██ ▄█▀    ▄▄▄██▀▀▀▓█████  ▒█████   ███▄    █   ▄████     █     █░ ▒█████   ▒█████   ███▄    █   ▄████ \n' +
'▓██░  ██▒▒████▄    ▓██ ▒ ██▒ ██▄█▒       ▒██   ▓█   ▀ ▒██▒  ██▒ ██ ▀█   █  ██▒ ▀█▒   ▓█░ █ ░█░▒██▒  ██▒▒██▒  ██▒ ██ ▀█   █  ██▒ ▀█▒\n' +
'▓██░ ██▓▒▒██  ▀█▄  ▓██ ░▄█ ▒▓███▄░       ░██   ▒███   ▒██░  ██▒▓██  ▀█ ██▒▒██░▄▄▄░   ▒█░ █ ░█ ▒██░  ██▒▒██░  ██▒▓██  ▀█ ██▒▒██░▄▄▄░\n' +
'▒██▄█▓▒ ▒░██▄▄▄▄██ ▒██▀▀█▄  ▓██ █▄    ▓██▄██▓  ▒▓█  ▄ ▒██   ██░▓██▒  ▐▌██▒░▓█  ██▓   ░█░ █ ░█ ▒██   ██░▒██   ██░▓██▒  ▐▌██▒░▓█  ██▓\n' +
'▒██▒ ░  ░ ▓█   ▓██▒░██▓ ▒██▒▒██▒ █▄    ▓███▒   ░▒████▒░ ████▓▒░▒██░   ▓██░░▒▓███▀▒   ░░██▒██▓ ░ ████▓▒░░ ████▓▒░▒██░   ▓██░░▒▓███▀▒\n' +
'▒▓▒░ ░  ░ ▒▒   ▓▒█░░ ▒▓ ░▒▓░▒ ▒▒ ▓▒    ▒▓▒▒░   ░░ ▒░ ░░ ▒░▒░▒░ ░ ▒░   ▒ ▒  ░▒   ▒    ░ ▓░▒ ▒  ░ ▒░▒░▒░ ░ ▒░▒░▒░ ░ ▒░   ▒ ▒  ░▒   ▒ \n' +
'░▒ ░       ▒   ▒▒ ░  ░▒ ░ ▒░░ ░▒ ▒░    ▒ ░▒░    ░ ░  ░  ░ ▒ ▒░ ░ ░░   ░ ▒░  ░   ░      ▒ ░ ░    ░ ▒ ▒░   ░ ▒ ▒░ ░ ░░   ░ ▒░  ░   ░ \n' +
'░░         ░   ▒     ░░   ░ ░ ░░ ░     ░ ░ ░      ░   ░ ░ ░ ▒     ░   ░ ░ ░ ░   ░      ░   ░  ░ ░ ░ ▒  ░ ░ ░ ▒     ░   ░ ░ ░ ░   ░ \n' +
'               ░  ░   ░     ░  ░       ░   ░      ░  ░    ░ ░           ░       ░        ░        ░ ░      ░ ░           ░       ░ \n' +
'                                                                                                                                   \n' ]

const xangle = '\n' +
  '▒██   ██▒▄▄▄      ███▄    █  ▄████ ██▓   ▓█████ \n' +
  '▒▒ █ █ ▒▒████▄    ██ ▀█   █ ██▒ ▀█▓██▒   ▓█   ▀ \n' +
  '░░  █   ▒██  ▀█▄ ▓██  ▀█ ██▒██░▄▄▄▒██░   ▒███   \n' +
  ' ░ █ █ ▒░██▄▄▄▄██▓██▒  ▐▌██░▓█  ██▒██░   ▒▓█  ▄ \n' +
  '▒██▒ ▒██▒▓█   ▓██▒██░   ▓██░▒▓███▀░██████░▒████▒\n' +
  '▒▒ ░ ░▓ ░▒▒   ▓▒█░ ▒░   ▒ ▒ ░▒   ▒░ ▒░▓  ░░ ▒░ ░\n' +
  '░░   ░▒ ░ ▒   ▒▒ ░ ░░   ░ ▒░ ░   ░░ ░ ▒  ░░ ░  ░\n' +
  ' ░    ░   ░   ▒     ░   ░ ░░ ░   ░  ░ ░     ░   \n' +
  ' ░    ░       ░  ░        ░      ░    ░  ░  ░  ░\n' +
  '                                                \n'

const getRandomName = () => {
  const randomIndex = Math.floor(Math.random() * nameList.length)
  return nameList[randomIndex]
}
export default defineNuxtPlugin((nuxtApp) => {
  if (!window) return
  Object.defineProperty(window, 'callCreator', {
    value: () => {
      console.log('%c' + xangle, 'color: red;' )
      console.log('%c' + getRandomName(), 'color: red;')
    }
  })
})

